module.exports = __webpack_public_path__ + "b918a191facf7e2183ad8a684da324ae.svg";